import React from 'react';
import { useModuleAccess } from '../../permissions/useModuleAccess';

/**
 * Shown at top of a module when the user may view but not create or edit.
 */
export function ModuleAccessBanner({ moduleKey, className = '' }) {
  const { isReadOnly, canView, loading } = useModuleAccess(moduleKey);

  if (loading || !canView || !isReadOnly) {
    return null;
  }

  return (
    <div
      role="status"
      className={`mb-4 flex gap-3 rounded-xl border border-amber-200/90 bg-amber-50/95 px-4 py-3 text-sm text-amber-950 ${className}`}
    >
      <svg
        className="mt-0.5 h-5 w-5 shrink-0 text-amber-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p>
        <span className="font-semibold">View only.</span>{' '}
        You can browse this section but cannot add, edit, or delete records. Contact your
        administrator if you need more access.
      </p>
    </div>
  );
}
